module.exports = __webpack_public_path__ + "img/kise_no.6a43655a.png";